import { ClassificationClass } from './classificationClass';
import { ClassificationLocation } from './classificationLocation';
import { z } from 'zod';

export type ClassificationDetection = z.infer<typeof ClassificationDetection>;

export const ClassificationDetection = z.object({
    class: ClassificationClass,
    location: ClassificationLocation,
});
